module.exports = __webpack_public_path__ + "static/paris-270ad1b0bc1128115f61114ee7fb7785.jpg";